<template>
  <div
    v-if="encId.length"
    class="p-2"
  >
    <div class="d-flex">
      <div
        v-if="pageInfo"
        class="flex-grow-1"
      >
        <h3>
          <feather-icon
            v-if="pageInfo.icon"
            :icon="pageInfo.icon"
            size="20"
          />
          {{ pageInfo.title }}
          <br><small v-if="globalFilter">
            {{ globalFilter.fromWave }} - {{ globalFilter.toWave }}
          </small>
        </h3>

      </div>
    </div>
    <div
      v-if="pageInfo && pageInfo.description"
      class="p-2"
    >
      <h6>{{ pageInfo.description }}</h6>
    </div>

    <box
      v-for="box in boxes"
      :id="'box_'+box.id"
      :ref="'box_'+box.id"
      :key="box.id"
      :xbox="box"
      :running-for-pdf="true"
    />

  </div>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'
import Box from '@/layouts/components/Box.vue'
import { getUserData, isPermitted } from '@/auth/utils'
import { periodList } from '@core/layouts/utils'
import { initialAbility } from '@/libs/acl/config'
import dayjs from 'dayjs'

export default {
  components: {
    Box,
  },
  data() {
    return {
      globalFilter: null,
      pageId: this.$route.params.id,
      encId: this.$route.params.encId,
      pageInfo: null,
      boxes: [],
      boxRequest: null,
      userData: null,
    }
  },
  watch: {
    $route(val) {
      this.pageId = val.params.id
      this.encId = val.params.encId
      this.getPageInfo()
      this.getBoxes('watch')
    },
  },
  async created() {
    this.getBoxes('created')
    this.getPageInfo()
    await this.switchUser()
    this.userData = getUserData()
    await periodList()
    this.globalFilter = this.$store.state.globals.globalFilter
    this.globalFilter.toWave = dayjs().subtract(1, 'months').format('YYYYMM')
    this.globalFilter.fromWave = dayjs().subtract(1, 'months').startOf('year').format('YYYYMM')
  },
  methods: {
    async switchUser() {
      useJwt.axiosIns.post(`user/authenticateforpdf/${this.encId}`)
        .then(async response => {
          // LOG OUT FROM CURRENT USER
          localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
          localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)

          // Remove userData from localStorage
          localStorage.removeItem('userData')

          // Reset ability
          this.$ability.update(initialAbility)

          // USE OTHER USER DATA
          const { userData } = response.data
          useJwt.setToken(response.data.accessToken)
          useJwt.setRefreshToken(response.data.refreshToken)
          localStorage.setItem('userData', JSON.stringify(userData))
          this.$ability.update(userData.ability)

          await periodList()
        })
        .catch(e => {
          console.log(e)
        })
    },
    isPermitted(code) {
      // skip check if pdf export
      if (!this.userData) {
        return false
      }
      return isPermitted(this.userData.role, code, this.userData.userGroups)
    },
    getPageInfo() {
      if (this.pageId) {
        useJwt.axiosIns.get(`page/${this.pageId}`)
          .then(response => {
            if (response.data) {
              this.pageInfo = response.data
            }
          })
          .catch(e => {
            console.log(e)
          })
      }
    },
    checkUserGroupsForBox(box) {
      if (box.userGroups && box.userGroups.length) {
        let found = false
        box.userGroups.forEach(ug => {
          if (this.userData.userGroups.find(uug => uug.id === ug)) {
            found = true
          }
        })
        return found
      }
      return true
    },
    getBoxes() {
      if (this.pageId) {
        this.boxRequest = this.$store.state.globals.globalFilter
        if (this.boxRequest && this.boxRequest.fromWave > 0 && this.boxRequest.toWave > 0) {
          this.boxRequest.toWave = dayjs().subtract(1, 'months').format('YYYYMM')
          this.boxRequest.fromWave = dayjs().subtract(1, 'months').startOf('year').format('YYYYMM')
          useJwt.axiosIns.get(`box/${this.pageId}`)
            .then(response => {
              if (response.data) {
                this.boxes = response.data.filter(box => this.checkUserGroupsForBox(box))

                this.boxes.forEach(element => {
                  const newElem = element
                  newElem.boxConfig = JSON.parse(element.configJson)
                })
              }
            })
            .catch(e => {
              console.log(e)
            })
        } else {
          setTimeout(() => {
            this.getBoxes('setTimeout')
          }, 100)
        }
      } else {
        this.$router.push({ name: 'auth-login' })
      }
    },

  },
}
</script>

<style>
.itemlabel{vertical-align:middle;margin-left:8px;}
body{ background-color: white !important;}
.card{
  box-shadow: none !important;
  border:#f0f0f0 2px solid;
}
.dropdown.b-dropdown{
  display: none;
}
</style>
